import { IGenList, QList, GenData } from '@educraft/base';

/**
 * A simple list generator that stores static items.
 * Port of C# EduFrame.OrderGen.Generators.SimpleGen.
 */
export class SimpleGenList implements IGenList {
  private readonly item: QList;

  /**
   * Create from string values with auto-generated numeric keys (1-based).
   */
  constructor(...values: string[]);
  /**
   * Create from string values with custom key selector.
   */
  constructor(keySelector: (index: number) => string, ...values: string[]);
  /**
   * Create from an array of QList objects.
   */
  constructor(items: QList[]);
  constructor(...args: any[]) {

    if (args.length === 0) {
      this.item = { items: [] };
    } else if (Array.isArray(args[0]) && args[0].length > 0 && typeof args[0][0] === 'object') {
      // QList[] constructor
      this.item = { items: args[0] as [] };
    } else if (typeof args[0] === 'function') {
      // keySelector constructor
      const keySelector = args[0] as (i: number) => string;
      const values = args.slice(1) as string[];

      this.item = {
        items: values.map((value, i) => ({
          key: keySelector(i),
          value,
        })),
      };
    } else {
      // Simple strings constructor (default 1-based keys)
      const values = args as string[];
      this.item = {
        items: values.map((value, i) => ({
          key: `${i + 1}`,
          value,
        })),
      };
    }
  }

  generate(data: GenData): QList {
    return this.item;
  }
}
